import { IBusinessListForecastForReceiptResult } from '../domains/entities/businessListForecastForReceiptResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { GetCustomerForecastResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { IBusinessForCustomerForecast } from '@/coreDomainsModule/entities/businessForCustomerForecast';
import { CustomerForecastAdapter } from './customerForecastAdapter';
import { BusinessCustomerForecastFactory } from '@/coreDomainsModule/factories/customerForecastFactory';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * responseをUI用にresultに変換する
 * TODO: ひとまず仕入先内示作成ステータスをbusinessForecastStateで管理
 */
export class BusinessListForecastForReceiptAdapter {
  /**
   * responseをUI用にresultに変換する
   * @param response - APIレスポンス
   * @param pagingOptions - ページングオプション
   */
  public static adapt = (
    response: GetCustomerForecastResponseAllOfResult,
    pagingOptions: IPagingOptions
  ): IBusinessListForecastForReceiptResult => {
    try {
      const data: IBusinessForCustomerForecast[] = response.data.map((businessAndForecast) => {
        return BusinessCustomerForecastFactory.create({
          businessId: businessAndForecast.baseBusinessId,
          aggregateBusinessId: businessAndForecast.aggregateBusinessId,
          baseBusinessResponsibleUsers:
            businessAndForecast.baseBusinessResponsibleUsers?.map((user) =>
              UserAccountFactory.create({ email: user.id, name: user.name })
            ) ?? [],
          supplierNumber: businessAndForecast.supplierNumber,
          supplierName: businessAndForecast.supplierName,
          businessNumber: businessAndForecast.businessNumber,
          businessName: businessAndForecast.businessName,
          package: businessAndForecast.package.addComma(),
          unit: businessAndForecast.unit,
          manufacturer: businessAndForecast.manufacturer,
          warehouseNumber: businessAndForecast.warehouseNumber,
          warehouse: businessAndForecast.warehouse,
          customerNumber: businessAndForecast.customerNumber,
          customerName: businessAndForecast.customerName,
          salesDestinationNumber: businessAndForecast.salesDestinationNumber,
          salesDestinationName: businessAndForecast.salesDestinationName,
          endUser: businessAndForecast.endUser,
          createdSupplierForecast: businessAndForecast.createdSupplierForecast,
          forecastForReceiptName: businessAndForecast.forecastForReceiptName,
          forecastForReceiptResponsibleUsers:
            businessAndForecast.forecastForReceiptResponsibleUsers?.map((user) =>
              UserAccountFactory.create({ email: user.id, name: user.name })
            ) ?? [],
          customerForecasts: businessAndForecast.customerAnnounces?.map((forecast) => CustomerForecastAdapter.adapt(forecast)) ?? [],
        });
      });
      return {
        result: data,
        pagingOptions: { ...response.pagingOptions },
      };
    } catch (error) {
      console.error('BusinessListForecastForReceiptAdapter.adapt', error);
      throw error;
    }
  };
}
